module.exports = __webpack_public_path__ + "img/5.031b2ea0.jpg";